import { formatDate } from './formatDate';

export const getDatesInRange = (
  startDate: Date,
  endDate: Date,
  holidays?: string[]
) => {
  const date = new Date(startDate.getTime());
  const dates = [];
  const saturday = 6;
  const sunday = 0;

  while (date <= endDate) {
    const { day, month, year } = formatDate(date);
    if (
      date.getDay() !== saturday &&
      date.getDay() !== sunday &&
      !holidays?.includes(`${year}-${month}-${day}`)
    ) {
      dates.push(new Date(date).toString());
    }
    date.setDate(date.getDate() + 1);
  }
  return dates;
};
